import { render, staticRenderFns } from "./averages.vue?vue&type=template&id=156a19a8"
import script from "./averages.vue?vue&type=script&lang=js"
export * from "./averages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports